import axios from "axios";
export * from "./apiAttachment";
export * from "./apiAdvisorReview";
export * from "./apiCognito";
export * from "./apiReports";
export * from "./apiInvestigation";
export * from "./apiCatalogues";
export * from "./apiForm";
export * from "./apiMessages";
export * from "./apiLanding";
export * from "./apiClientConfig";
export * from "./apiAssigment";
export * from "./apiEAM";
export * from "./apiNotification";
export { getUserDetail } from "./apiUsers";

// Worker
export const worker = "https://test.ethicsglobal.com";

// IF YOU CHANGE THIS VARIABLE DON'T COMMIT
// Host
export const host = "https://api.ethicsglobal.com";
// //export const host = "https://djaguar.herokuapp.com";
//export const host = "http://localhost:8000";
// export const host = "https://cr7.ngrok.io/";
// export const host = "https://ar.ngrok.io/";
// export const host = "https://jaguar.ngrok.io/";

// export const host = process.env.REACT_APP_HOST;

export const baseURL = `${host}`;
export const baseWork = `${worker}`;
export const apiCall = axios.create({ baseURL });
export const workerCall = axios.create({ baseWork });
